import React from 'react';
import TrueEPIntro from '../../../components/security/TrueEPIntro';
import TrueEPComparison from '../../../components/security/TrueEPComparison';
import TrueEPMainFeatures from '../../../components/security/TrueEPMainFeatures';
import TrueEPReports from '../../../components/security/TrueEPReports';
import TrueEPSupportEnv from '../../../components/security/TrueEPSupportEnv';

import styles from "../../../styles/security/SecProduct.module.css";

const SecProduct = () => {
  return (
    <main className={styles.container}>
      <TrueEPIntro styles={styles} />
      <TrueEPComparison styles={styles} />
      <TrueEPMainFeatures styles={styles} />
      <TrueEPReports styles={styles} />
      <TrueEPSupportEnv styles={styles} />
    </main>
  )
}

export default SecProduct